module.exports = "<span> <a class=begrip-link id={{::key}} ng-click=::openTerm(key) ng-if=::!mode><span compile=::word></span> <i class=\"fa fa-question-circle begrip-icoon\"></i></a> <b ng-if=\"::mode==='highlight'\" compile=word></b> </span> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/term/term.html
// module id = 1135
// module chunks = 0